module.exports = __webpack_public_path__ + "img/20170813_100159-min.51c6c2ed.jpg";